export default ({ isFetchingLoggedInUserDetails, isSharePage, referralUrl }) => {
    if (isFetchingLoggedInUserDetails) { return "preload_logged_in_user_data"; }
    if ((!isSharePage && !referralUrl) || referralUrl === undefined) { return "get_number"; }
    if (isSharePage || referralUrl !== undefined) { return "refer_widget"; }
    return undefined;
};
